<template>
  <v-container grid-list-md fluid class="main-container">
    <v-dialog v-model="showEndDialog" max-width="80%">
      <v-card>
        <v-card-text>
          <p>サーベイが完了しました。ブラウザを閉じてください。</p>
          <p>The investigation has been completed. Close your web browser.</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-alert
      v-if="endDate&&isClosed"
      :value="isClosed"
      color="info"
      icon="info"
      outline
    >
    <p>回答期間は終了しました。</p>
    <p>The answer period is over.</p>
    </v-alert>
    <v-alert
      v-if="isCompleted"
      :value="isCompleted"
      color="info"
      icon="info"
      outline
    >
    <p>回答は完了しました。ご協力ありがとうございます。</p>
    <p>The survey has been completed. Thank you for answering.</p>
    </v-alert>
    <!-- <v-stepper v-model="currentStep" vertical v-if="isOpen　&& !isCompleted && showQuestionSections.length > 0"> -->
    <v-stepper v-model="currentStep" vertical　v-if="isOpen && !isCompleted">
      <div v-for=" (section, i) in showQuestionSections" :key="i">
        <v-stepper-step :complete="false" :step="i + 1">{{section.name}}</v-stepper-step>
        <v-card>
          <v-card-text class="question-text">
            <div v-if="section.type=='Info'">
              <v-stepper-content :step="i + 1">
                <div v-html="section.content"></div>
                <v-layout row justify-center>
                  <div v-show="showNextBtn">
                    <v-btn @click="backStep">Back</v-btn>
                  </div>
                  <v-spacer></v-spacer>
                  <div v-show="showNextBtn">
                    <v-btn @click="nextStep">Next</v-btn>
                  </div>
                  <div v-show="!showNextBtn">
                    <v-btn @click="endSurvey">終了/Finish</v-btn>
                  </div>
                </v-layout>
              </v-stepper-content>
            </div>
            <div v-if="section.type=='Start'">
              <v-stepper-content :step="i + 1">
                <html-with-fields-inserted
                  :content="section.content"
                  :insert-fields="insertFileds"
                />
                <div v-if="answer_sheet" class="name-box-container">
                  <v-layout align-center justify-center row fill-height>
                    <v-flex md3 class="name-box">対象者：{{answer_sheet.subject_name}} 様</v-flex>
                    <v-flex md3 offset-md1 class="name-box">入力者：{{answer_sheet.name}} 様</v-flex>
                  </v-layout>
                </div>
                <template v-if="answer_sheet && answer_sheet.type=='subject'">
                  <v-layout align-start justify-start row fill-height>
                    <v-flex md6>
                      <v-alert :value="true" color="info" outline>あなたの生年月日を入力して、次へボタンを押して開始してください</v-alert>
                    </v-flex>
                  </v-layout>
                  <v-layout align-start justify-start row fill-height>
                    <v-flex md5>
                      <birthday-input v-model="answer_sheet.birthday" :error.sync="birthdayError" />
                    </v-flex>
                  </v-layout>性別
                  <v-layout align-start justify-start row fill-height>
                    <v-flex md2>
                      <v-select :items="['男','女']" v-model="answer_sheet.sex"></v-select>
                    </v-flex>
                  </v-layout>
                </template>
                <v-layout align-start justify-start row fill-height>
                  <v-spacer></v-spacer>
                  <div v-show="showNextBtn">
                    <v-btn
                      @click="nextStep"
                      :disabled="isBirthdayErrorOccuring || (answer_sheet.type=='subject' && !answer_sheet.sex && !answer_sheet.birthday)"
                    >Next</v-btn>
                  </div>
                </v-layout>
              </v-stepper-content>
            </div>
            <div v-if="section.type=='End'">
              <v-stepper-content :step="i + 1">
                <html-with-fields-inserted
                  :content="section.content"
                  :insert-fields="insertFileds"
                />
                <v-layout row justify-center>
                  <div>
                    <v-btn @click="backStep">Back</v-btn>
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                    <v-btn @click="endSurvey">終了/Finish</v-btn>
                  </div>
                </v-layout>
              </v-stepper-content>
            </div>
            <div v-if="section.type=='SelectQuestions' && answer_sheet">
              <v-stepper-content :step=" i + 1">
                <questions
                  :section="section"
                  v-model="answer_sheet.result[i]"
                  :type="answer_sheet.type"
                  @backStep="backStep"
                  @updateAnswers="updateAnswers"
                  @nextStep="nextStep"
                />
              </v-stepper-content>
            </div>
            <div v-if="section.type=='CommentQuestions'  && answer_sheet">
              <v-stepper-content :step="i + 1">
                <comments
                  :section="section"
                  v-model="answer_sheet.result[i]"
                  :type="answer_sheet.type"
                  :insert-fields="insertFileds"
                  @backStep="backStep"
                  @nextStep="nextStep"
                />
              </v-stepper-content>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-stepper>
  </v-container>
</template>

<script>
import Questions from "@/components/surveys/selection_questions.vue";
import Comments from "@/components/surveys/comments.vue";
import BirthdayInput from "@/components/common/simpleDateInput.vue";
import HtmlWithFieldsInserted from "@/components/common/htmlWithFieldsInserted.vue";
import db from "@/components/firebaseInit";
import {
  unixtimeToShortJapaneseFormattedDatetime,
  unixtimeToShortJapaneseFormattedDate,
  getUnixtime
} from "@/utils/datetime.js";
import { scheduleDictionary } from "@/utils/schedules.js";

export default {
  components: {
    Questions,
    Comments,
    BirthdayInput,
    HtmlWithFieldsInserted
  },
  props: [],
  data() {
    return {
      test: 100000,
      currentStep: 0,
      answer_sheet: null,
      question_sheet: null,
      surveyDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id),
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets")
        .doc(this.$route.params.answer_sheet_id),
      showQuestionSections: [],
      showEndDialog: false,
      selectedQuestionsPageLength: 0,
      birthdayError: {},
      insertFileds: [],
      endDate: 0
    };
  },
  computed: {
    isEndPage(){
      return this.currentStep > 1 &&(this.currentStep == this.showQuestionSections.length);
    },
    showBackBtn() {
      return this.currentStep != 1;
    },
    showNextBtn() {
      return this.currentStep != this.showQuestionSections.length;
    },
    isBirthdayErrorOccuring() {
      if (
        this.birthdayError &&
        this.birthdayError.code &&
        this.birthdayError.code != "no-error"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isOpen() {
      return getUnixtime() < this.endDate;
    },
    isClosed() {
      return getUnixtime() > this.endDate;
    },
    isCompleted(){
      return this.answer_sheet && this.answer_sheet.status == "完了"
    }
  },
  watch:{
    async isEndPage(){
      debugger
      this.answer_sheet.status = "完了前";
      await this.answerDbRef
        .set(this.answer_sheet, { merge: true })
        .catch(e => {
          alert(
            "保存に失敗しました。通信環境の良い場所でもう一度実施してください。"
          );
        });
    }
  },
  methods: {
    async updateAnswers() {
      this.answer_sheet.status = "回答中";
      await this.answerDbRef
        .set(this.answer_sheet, { merge: true })
        .catch(e => {
          alert(
            "保存に失敗しました。通信環境の良い場所でもう一度実施してください。"
          );
        });
    },
    async nextStep() {
      this.answer_sheet.status = "回答中";
      await this.answerDbRef
        .set(this.answer_sheet, { merge: true })
        .catch(e => {
          alert(
            "保存に失敗しました。通信環境の良い場所でもう一度実施してください。"
          );
        });
      this.currentStep = this.currentStep + 1;
    },
    backStep() {
      this.currentStep = this.currentStep - 1;
    },
    async endSurvey() {
      this.answer_sheet.status = "完了";
      await this.answerDbRef
        .set(this.answer_sheet, { merge: true })
        .catch(e => {
          alert(
            "保存に失敗しました。通信環境の良い場所でもう一度実施してください。"
          );
        });
      this.showEndDialog = true;
    },
    initAnswer() {
      const ans = {};
      this.showQuestionSections.forEach((sec, i) => {
        if (sec.type == "SelectQuestions") {
          ans[i] = {};
          sec.questions.forEach(q => (ans[i][q.id] = 0));
        } else if (sec.type == "CommentQuestions") {
          ans[i] = new Array(sec.maxOfComments).fill("");
        } else {
          ans[i] = [];
        }
      });
      return ans;
    },
    async getAnswerSheet() {
      const doc = await this.answerDbRef.get();
      var data = doc.data();
      // this.question_sheet= data.type == "self" ? this.survey.self_sheet : this.survey.evaluator_sheet
      this.showQuestionSections = this.question_sheet.sections.filter(
        s => !s.isShow || s.isShow[data.type]
      );

      if (data.status == "未実施") {
        data.result = this.initAnswer();
      }
      this.answer_sheet = data;
      this.currentStep = 1;
    },
    async getQuestionPaper() {
      const doc = await this.surveyDbRef.get();
      this.survey = doc.data();
      this.question_sheet = this.survey.question_sheet;
      scheduleDictionary.forEach(sch => {
        this.insertFileds.push({
          find: sch.name + "日時",
          replace: unixtimeToShortJapaneseFormattedDatetime(
            this.survey[sch.key]
          )
        });
      });
      this.endDate = this.survey.end_date;
      this.insertFileds.push({ find: "研修名", replace: this.survey.name });
      this.insertFileds.push({
        find: "研修日",
        replace: unixtimeToShortJapaneseFormattedDate(this.survey.training_date)
      });
      this.getAnswerSheet();
    },
    init() {
      this.getQuestionPaper();
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.question-text {
  padding: 0px;
}
.name-box {
  border: 1px solid gray;
  padding: 5px;
}
.name-box-container {
  margin-bottom: 20px;
}
.main-container{
  max-width:1200px;
}
</style>


